/**
 * The mobile top bar.
 *
 * Only visible below 769px, where the sidebar becomes a drawer. Without it
 * there is no way to open that drawer - which was the state of the live app
 * until now: the nav was `display: none` on a phone and nothing replaced it.
 */
export function MobileTopBar({ title, brandName, open, onToggle, badge = 0 }: {
  title: string;
  brandName: string;
  open: boolean;
  onToggle: () => void;
  /** Same count as the Work nav badge; the drawer is closed, so the menu button carries the dot. */
  badge?: number;
}) {
  return (
    <header className="mobile-topbar">
      <button
        className="mt-menu"
        type="button"
        aria-label="Open navigation"
        aria-expanded={open}
        aria-controls="app-sidebar"
        onClick={onToggle}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
        {badge > 0 && !open && <span className="mt-badge" aria-hidden="true" />}
      </button>
      <img className="mt-logo" src="/aditor-logo.png" alt="" />
      <div className="mt-title"><strong>{brandName}</strong><span>{title}</span></div>
    </header>
  );
}
